import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Brand";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

function Section({ title, children }) {
    return (
        <section className="border-t border-nm-line py-8 first:border-t-0">
            <h2 className="text-xl font-bold tracking-tight text-nm-ink">{title}</h2>
            <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-nm-muted">{children}</div>
        </section>
    );
}

export default function Privacidad() {
    return (
        <div className="min-h-screen bg-nm-bg">
            <header className="border-b border-nm-line bg-nm-bg/90 backdrop-blur">
                <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
                    <Link to="/"><Wordmark /></Link>
                    <Link to="/"><Button variant="ghost" className="text-nm-ink"><ArrowLeft className="mr-1 h-4 w-4" /> Inicio</Button></Link>
                </div>
            </header>

            <main className="mx-auto max-w-3xl px-6 py-12" data-testid="privacidad-page">
                <h1 className="text-4xl font-bold tracking-tight text-nm-ink">Privacidad</h1>
                <p className="mt-3 text-nm-muted">
                    Aquí te contamos, en claro, qué datos guardamos, para qué y durante cuánto tiempo.
                    Sin plantillas ni letra pequeña.
                </p>

                <div className="mt-8">
                    <Section title="Qué datos guardamos">
                        <p>Guardamos solo lo necesario para que la herramienta funcione:</p>
                        <ul className="list-disc space-y-1 pl-5">
                            <li>Tu <strong className="text-nm-ink">nombre</strong> y tu <strong className="text-nm-ink">correo electrónico</strong>, para crear tu cuenta y avisarte.</li>
                            <li>Tu <strong className="text-nm-ink">contraseña</strong>, siempre cifrada. Nunca la vemos ni la podemos recuperar.</li>
                            <li>Los <strong className="text-nm-ink">contactos</strong> que tú añades (nombre, teléfono, correo, notas) para organizarte el seguimiento.</li>
                            <li>Tu <strong className="text-nm-ink">progreso</strong> en la ruta y tu actividad dentro de la app.</li>
                        </ul>
                    </Section>

                    <Section title="Para qué los usamos">
                        <p>
                            Únicamente para prestarte el servicio: mostrarte tu panel, organizar tus contactos,
                            recordarte a quién contactar y enviarte tu resumen diario. No los usamos para publicidad
                            ni los vendemos a nadie.
                        </p>
                    </Section>

                    <Section title="Con quién los compartimos">
                        <p>
                            No cedemos tus datos a terceros con fines comerciales. Solo se apoyan en los proveedores
                            técnicos que hacen funcionar la aplicación (alojamiento y envío de correo), y siempre con
                            el mínimo necesario. Mientras no haya un proveedor de correo configurado, los mensajes ni
                            siquiera salen: se registran dentro de tu cuenta.
                        </p>
                    </Section>

                    <Section title="Cuánto tiempo los guardamos">
                        <p>
                            Mantenemos tus datos mientras tengas la cuenta activa. Si eliminas tu cuenta desde
                            <em> Ajustes</em>, borramos tu perfil y tus contactos.
                        </p>
                    </Section>

                    <Section title="Tus derechos">
                        <p>
                            Puedes acceder, corregir o eliminar tus datos en cualquier momento. Para borrarlo todo,
                            entra en <Link to="/app/ajustes" className="text-nm-accent">Ajustes → Eliminar mi cuenta</Link>.
                            Si prefieres que lo hagamos nosotros o tienes cualquier duda, escríbenos o llámanos al{" "}
                            <a href="tel:+34694406037" className="text-nm-accent">+34 694 406 037</a>.
                        </p>
                    </Section>

                    <Section title="Contacto">
                        <p>
                            Responsable: Network Mastery · Teléfono:{" "}
                            <a href="tel:+34694406037" className="text-nm-accent">+34 694 406 037</a>.
                        </p>
                    </Section>
                </div>
            </main>

            <Footer />
        </div>
    );
}
